import * as Yup from "yup";

export const visitorSignUpDetailsObject = {
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
  gender: "",
};

export const visitorSignUpValidationSchema = Yup.object().shape({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string(),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone_number: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
  gender: Yup.string().required("Gender is required"),
});
